<template>
    <v-container fluid class="pa-0 statistics-view">
        <div class="statistics-tabbar">
            <select-option-students underline no-grow :custom-options="sections" :value="currentSection" @change="onClickMenu" />
        </div>

        <statistics-form v-show="!isHabits" with-last-weeks @load="onLoadDocs" @loadLastWeeks="lastWeeks = $event" @reset="onReset"
            @load:compare="compareDocs = $event" @loadLastWeeks:compare="compareLastWeeks = $event"
            @change:labels="labels = $event"
            @loading="loading = $event"
            @change:date:start="date = $event"
            @change:date:end="endDate = $event" @change:student="studentId = $event"
            @change:teamStudents="teamStudents = $event" @change:coach="coachId = $event"
            :currentOption="option" :isCompetence="isCompetence" :isInjury="isInjury"
            :isWellness="isWellness" @change:students="students = $event"
            @change:teamId="teamId = $event" ref="form">
            <template #scope>
                <tabs-group dense :tabs="scopeTabs" :value="option" @change="option = $event" />
            </template>
        </statistics-form>

        <div class="statistics-body pa-3" data-share-target="statistics">
        <statistics-habits v-if="isHabits" :coach-id="habitsCoachId" />
        <template v-if="currentSection === 'statistics'">
            <skeleton-loader v-if="loading" type="stat-grid" />
            <stats-grid v-else-if="docs.length > 0" :count="6" :expanded="expandedCard">
                <acute-chronic-chart :docs="lastWeeks" :compare-docs="compareLastWeeks" :main-label="labels.main"
                    :compare-label="labels.compare" expandable :expanded="expandedCard === 0"
                    @toggle:expand="toggleExpand(0)" />
                <last-weeks-chart :docs="lastWeeks" expandable :expanded="expandedCard === 1"
                    @toggle:expand="toggleExpand(1)" />
                <sessions-chart :docs="docs" :date="date" expandable :expanded="expandedCard === 2"
                    @toggle:expand="toggleExpand(2)" />
                <exercises-chart :docs="docs" :coach-id="coachId" :compare-docs="compareDocs"
                    :compare-label="labels.compare" expandable :expanded="expandedCard === 3"
                    @toggle:expand="toggleExpand(3)" />
                <variables-chart :docs="docs" :compare-docs="compareDocs" :compare-label="labels.compare" expandable
                    :expanded="expandedCard === 4" @toggle:expand="toggleExpand(4)" />
                <wellness-chart :docs="docs" :compare-docs="compareDocs" :compare-label="labels.compare" expandable
                    :expanded="expandedCard === 5" @toggle:expand="toggleExpand(5)" />
            </stats-grid>
        </template>
        <skeleton-loader v-if="loading && isInjury" type="stat-grid" />
        <skeleton-loader v-else-if="loading && isWellness" type="stat-table" />
        <skeleton-loader v-else-if="loading && isCompetence" type="stat-grid" />
        <statistics-competences v-if="isCompetence && !loading && docs.length > 0" :docs="docs" :start-date="date"
            :end-date="endDate" :student-id="studentId" :students="students" :team-id="teamId" />
        <statistics-injuries v-if="isInjury && !loading && docs.length > 0" :docs="docs" :teamStudents="teamStudents" @reloadDocs="onReloadDocs" />
        <statistics-wellness v-if="isWellness && !loading && docs.length > 0" :docs="docs" :teamStudents="teamStudents"
            :teamId="teamId" :startDate="date" :endDate="endDate" :coachId="coachId" />

        <div v-if="searched && !loading && docs.length === 0 && !isHabits" class="stats-empty">
            <v-icon size="46" color="txtMuted">mdi-chart-box-outline</v-icon>
            <p>{{ $t('statistics.no_data') }}</p>
        </div>
        </div>

        <ai-chat-drawer />
    </v-container>
</template>

<script>

import StatisticsForm from "@/components/statistics/StatisticsForm";
import WellnessChart from "@/components/statistics/WellnessChart";
import SessionsChart from '../../components/statistics/SessionsChart.vue';
import VariablesChart from '../../components/statistics/VariablesChart.vue';
import LastWeeksChart from '../../components/statistics/LastWeeksChart.vue';
import ExercisesChart from '../../components/statistics/ExercisesChart.vue';
import AcuteChronicChart from '../../components/statistics/AcuteChronicChart.vue';
import SelectOptionStudents from '../../components/coach/SelectOptionStudents.vue';
import TabsGroup from '../../components/common/TabsGroup.vue';
import StatisticsCompetences from '../../components/statistics/StatisticsCompetences.vue';
import StatisticsInjuries from '../../components/statistics/StatisticsInjuries.vue';
import StatisticsWellness from '../../components/statistics/StatisticsWellness.vue';
import SkeletonLoader from '../../components/common/SkeletonLoader.vue';
import AiChatDrawer from '@/components/coach/ai/AiChatDrawer';
import StatsGrid from '../../components/statistics/StatsGrid.vue';
import StatisticsHabits from '../../components/statistics/StatisticsHabits.vue';
import { mapState } from 'vuex';
export default {
    components: { WellnessChart, StatisticsForm, SessionsChart, VariablesChart, LastWeeksChart, ExercisesChart, AcuteChronicChart, SelectOptionStudents, TabsGroup, StatisticsCompetences, StatisticsInjuries, StatisticsWellness, SkeletonLoader, StatsGrid, StatisticsHabits, AiChatDrawer },
    data() {
        return {
            docs: [],
            date: null,
            endDate: null,
            studentId: null,
            coachId: null,
            lastWeeks: [],
            compareDocs: null,
            compareLastWeeks: null,
            labels: { main: null, compare: null },
            option: 'students',
            currentSection: 'statistics',
            teamStudents: [],
            students: [],
            teamId: null,
            loading: false,
            searched: false,
            expandedCard: null,
        }
    },
    computed: {
        sections(vm = this) {
            return [
                { name: vm.$t('common.statistics'), value: 'statistics' },
                { name: vm.$t('common.wellness'), value: 'wellness', feature: 'wellnessStatistics' },
                { name: vm.$t('common.competences'), value: 'competence', feature: 'competencesStatistics' },
                { name: vm.$t('common.injuries'), value: 'injury', feature: 'injuriesStatistics' },
                { name: vm.$t('habits.title'), value: 'habits', feature: 'habits' },
            ]
        },
        ...mapState(['libraryCoach']),
        isHabits(vm = this) {
            return vm.currentSection === 'habits'
        },
        habitsCoachId(vm = this) {
            if (vm.isCompany) return vm.libraryCoach?.id || null
            return vm.currentUser?.uid || null
        },
        isCompetence(vm = this) {
            return vm.currentSection === 'competence'
        },
        isInjury(vm = this) {
            return vm.currentSection === 'injury'
        },
        isWellness(vm = this) {
            return vm.currentSection === 'wellness'
        },
        options(vm = this) {
            if (vm.isInjury || vm.isWellness) {
                return [
                    { name: `${this.$t('common.team')}s`, value: 'teams', icon: 'mdi-account-multiple' },
                    { name: `${this.$t('common.group')}s`, value: 'groups', icon: 'mdi-account-multiple' }
                ]
            }
            let options = [{ name: this.$t('common.students'), value: 'students', icon: 'mdi-account' }]
            if (!vm.isCompetence) options.push({ name: `${this.$t('common.group')}s`, value: 'groups', icon: 'mdi-account-multiple' })
            options.push({ name: `${this.$t('common.team')}s`, value: 'teams', icon: 'mdi-account-multiple' })
            return options
        },
        scopeTabs(vm = this) {
            return vm.options.map(o => ({ label: o.name, value: o.value }))
        },
        isTeamOption(vm = this) {
            return vm.option === 'teams'
        }
    },
    methods: {
        toggleExpand(index) {
            const vm = this
            vm.expandedCard = vm.expandedCard === index ? null : index
        },
        onLoadDocs(docs) {
            const vm = this
            vm.docs = docs
            vm.searched = true
            if (!vm.coachId) vm.coachId = vm.currentUser.uid
        },
        onReset() {
            const vm = this
            vm.docs = []
            vm.lastWeeks = []
            vm.compareDocs = null
            vm.compareLastWeeks = null
            vm.labels = { main: null, compare: null }
            vm.studentId = null
            vm.teamStudents = []
            vm.teamId = null
            vm.expandedCard = null
            vm.searched = false
        },
        onClickMenu(section) {
            const vm = this;
            vm.currentSection = section
            vm.onReset()
            vm.students = []
            vm.option = (section === 'injury' || section === 'wellness') ? 'teams' : 'students'
        },
        onReloadDocs() {
            const vm = this;
            vm.$refs.form.loadDocs()
        }
    },
}
</script>

<style scoped>
.switch-chart {
    position: absolute;
    right: 8px;
    top: 8px;
    z-index: 1;
}

.statistics-tabbar {
    padding: 0 24px;
    border-top: 1px solid var(--v-outline-base);
    border-bottom: 1px solid var(--v-outline-base);
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.statistics-tabbar::-webkit-scrollbar {
    display: none;
}

.statistics-body {
    min-height: 0;
}

@media (max-width: 760px) {
    .statistics-tabbar {
        padding: 0 8px;
    }
}

.stats-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 72px 16px;
    text-align: center;
    color: var(--v-txtMuted-base);
}

.stats-empty p {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
}

</style>